import React from "react";
import Button, { ButtonProps } from "../../button/Button";
import useThemeService from "../../../services/theme-service/ThemeService";
import { Edit } from "../../svg/svgImageList";

export interface EditButtonProps extends ButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export default function EditButton({ onClick, disabled, tooltipKey: tooltip }: EditButtonProps) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="edit"
      onClick={onClick}
      disabled={disabled}
      tooltipKey={tooltip}
      icon={{
        svg: Edit,
        textKey: "general.edit",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-edit"]),
      }}
    />
  );
}
